import Action from "../base/action";

class MoveAndRotate extends Action {
    model;
    position = new THREE.Vector3();
    quaternion = new THREE.Quaternion();
    scale = new THREE.Vector3();

    constructor(props) {
        super(props);
        this.transitionValues = props.transitionValues;
        this.model = props.model;

        const {position, quaternion, scale} = Object.assign({
            position: [0, 0, 0],
            quaternion: [0, 0, 0, 1],
            scale: [1, 1, 1]
        }, props);

        this.position.set(...position);
        this.quaternion.set(...quaternion);
        this.scale.set(...scale);
    }

    async execute() {
        throw new Error("subclass responsibility");
    }

    getComposedMatrix() {
        return new THREE.Matrix4().compose(this.position, this.quaternion, this.scale);
    }
}

export default MoveAndRotate;
